
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingPages/DecorLandingPage",
      function () {
        return require("private-next-pages/landingPages/DecorLandingPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingPages/DecorLandingPage"])
      });
    }
  